// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.columnInfoBill_XEMV8 {
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  margin: 10px 0;
  p {
    margin: 0;
  }

  .headerInfoBill_tBj7v {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    .search_uVceW {
      display: flex;
      align-items: center;
      gap: 10px;
      .button_O5x7C {
        text-decoration: underline;
        color: var(--_2-color);
        font-weight: 500;
        cursor: pointer;
      }
      .icon_omwhw {
        cursor: pointer;
      }

    }
  }
  .info_RAaAq {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 60px;
    img {
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      -o-border-radius: 50%;
      object-fit: cover;
      min-width: 30px;
      max-width: 30px;
      height: 30px;
    }

    p {
      color: var(--_09090b-color);
    }
    span {
      color: var(--_6-color);
      font-size: 13px;
    }
    .profile_SUShR {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      input{
        margin: 0;
        width: 100%;
        border-radius: 8px;
        padding: 8px;
        border: none;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        -ms-border-radius: 8px;
        -o-border-radius: 8px;
        background-color: var(--f4-background);
        outline: none;
      }
      textarea {
        max-height: 100px;
      }

      .infoSpan_kpxcU{
        font-size: 13px;
        color: var(--8C90A2-color);
      }
    }
  }

  textarea {
    width: 100%;
    resize: none;
    font-family: "Inter", sans-serif;
    color: var(--_71717a-color);
    resize: none;
    field-sizing: content;
    min-height: 60px;
    padding: 8px;
  }
  .inputContainer_LJe5d {
    display: flex;
    width: 100%;
    align-items: center;
    background-color: var(--f4-background);
    input::placeholder {
      color: var(--_71717a-color);
    }
  }
  textarea,
  .inputContainer_LJe5d {
    position:relative;
    box-sizing: border-box;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    resize: none;
    .searchContactInput_xbKNJ {
      font-size: 18px;
      font-weight: 500;
      margin: 0;
      width: 100%;
      border-radius: 8px;
      padding: 6px;
      border: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
      background-color: var(--f4-background);
      outline: none;
    }
  }
}

.contacts_k563h {
  position: absolute;
  top: calc(10px + 100%);
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  background-color: var(--white-background);
  border: 1px solid var(--ececf1-border);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  z-index: 99;
  .contact_RcGWV {
    display: flex;
    align-items: center;
    display: flex;
    gap: 10px;
    padding: 10px;
    cursor: pointer;
    img {
      border-radius: 999px;
      -webkit-border-radius: 999px;
      -moz-border-radius: 999px;
      -ms-border-radius: 999px;
      -o-border-radius: 999px;
      object-fit: cover;
    }
    p {
      color: var(--_09090b-color);
    }
    span {
      color: var(--_6-color);
      font-size: 13px;
    }
  }
  .newContactInfoClient_Ommdr {
    background-color: var(--f5-background);
    padding: 10px;
    padding-left: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}

.searchContainerIcon_O_n2O {
  background-color: var(--ececf1-background);
  padding: 4px;
  border-radius: 4px;
  height: 10px;
  width: 10px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  cursor: pointer;
}
.inputContainerNew_BTVd8{
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InfoBill/InfoClientBill/InfoClientBill.module.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,cAAc;EACd;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT;QACE,0BAA0B;QAC1B,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;MACjB;MACA;QACE,eAAe;MACjB;;IAEF;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB;MACE,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,iBAAiB;MACjB,eAAe;MACf,eAAe;MACf,YAAY;IACd;;IAEA;MACE,2BAA2B;IAC7B;IACA;MACE,sBAAsB;MACtB,eAAe;IACjB;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,WAAW;MACX;QACE,SAAS;QACT,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,0BAA0B;QAC1B,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,sCAAsC;QACtC,aAAa;MACf;MACA;QACE,iBAAiB;MACnB;;MAEA;QACE,eAAe;QACf,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,2BAA2B;IAC3B,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,sCAAsC;IACtC;MACE,2BAA2B;IAC7B;EACF;EACA;;IAEE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ;MACE,eAAe;MACf,gBAAgB;MAChB,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,sCAAsC;MACtC,aAAa;IACf;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,yCAAyC;EACzC,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,aAAa;IACb,eAAe;IACf;MACE,oBAAoB;MACpB,4BAA4B;MAC5B,yBAAyB;MACzB,wBAAwB;MACxB,uBAAuB;MACvB,iBAAiB;IACnB;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,sBAAsB;MACtB,eAAe;IACjB;EACF;EACA;IACE,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.columnInfoBill {\n  font-family: \"Inter\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  margin: 10px 0;\n  p {\n    margin: 0;\n  }\n\n  .headerInfoBill {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    .search {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      .button {\n        text-decoration: underline;\n        color: var(--_2-color);\n        font-weight: 500;\n        cursor: pointer;\n      }\n      .icon {\n        cursor: pointer;\n      }\n\n    }\n  }\n  .info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 60px;\n    img {\n      border-radius: 50%;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      object-fit: cover;\n      min-width: 30px;\n      max-width: 30px;\n      height: 30px;\n    }\n\n    p {\n      color: var(--_09090b-color);\n    }\n    span {\n      color: var(--_6-color);\n      font-size: 13px;\n    }\n    .profile {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      width: 100%;\n      input{\n        margin: 0;\n        width: 100%;\n        border-radius: 8px;\n        padding: 8px;\n        border: none;\n        -webkit-border-radius: 8px;\n        -moz-border-radius: 8px;\n        -ms-border-radius: 8px;\n        -o-border-radius: 8px;\n        background-color: var(--f4-background);\n        outline: none;\n      }\n      textarea {\n        max-height: 100px;\n      }\n\n      .infoSpan{\n        font-size: 13px;\n        color: var(--8C90A2-color);\n      }\n    }\n  }\n\n  textarea {\n    width: 100%;\n    resize: none;\n    font-family: \"Inter\", sans-serif;\n    color: var(--_71717a-color);\n    resize: none;\n    field-sizing: content;\n    min-height: 60px;\n    padding: 8px;\n  }\n  .inputContainer {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    background-color: var(--f4-background);\n    input::placeholder {\n      color: var(--_71717a-color);\n    }\n  }\n  textarea,\n  .inputContainer {\n    position:relative;\n    box-sizing: border-box;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    resize: none;\n    .searchContactInput {\n      font-size: 18px;\n      font-weight: 500;\n      margin: 0;\n      width: 100%;\n      border-radius: 8px;\n      padding: 6px;\n      border: none;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      background-color: var(--f4-background);\n      outline: none;\n    }\n  }\n}\n\n.contacts {\n  position: absolute;\n  top: calc(10px + 100%);\n  width: 100%;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-sizing: border-box;\n  background-color: var(--white-background);\n  border: 1px solid var(--ececf1-border);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  z-index: 99;\n  .contact {\n    display: flex;\n    align-items: center;\n    display: flex;\n    gap: 10px;\n    padding: 10px;\n    cursor: pointer;\n    img {\n      border-radius: 999px;\n      -webkit-border-radius: 999px;\n      -moz-border-radius: 999px;\n      -ms-border-radius: 999px;\n      -o-border-radius: 999px;\n      object-fit: cover;\n    }\n    p {\n      color: var(--_09090b-color);\n    }\n    span {\n      color: var(--_6-color);\n      font-size: 13px;\n    }\n  }\n  .newContactInfoClient {\n    background-color: var(--f5-background);\n    padding: 10px;\n    padding-left: 20px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n.searchContainerIcon {\n  background-color: var(--ececf1-background);\n  padding: 4px;\n  border-radius: 4px;\n  height: 10px;\n  width: 10px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  cursor: pointer;\n}\n.inputContainerNew{\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"columnInfoBill": `columnInfoBill_XEMV8`,
	"headerInfoBill": `headerInfoBill_tBj7v`,
	"search": `search_uVceW`,
	"button": `button_O5x7C`,
	"icon": `icon_omwhw`,
	"info": `info_RAaAq`,
	"profile": `profile_SUShR`,
	"infoSpan": `infoSpan_kpxcU`,
	"inputContainer": `inputContainer_LJe5d`,
	"searchContactInput": `searchContactInput_xbKNJ`,
	"contacts": `contacts_k563h`,
	"contact": `contact_RcGWV`,
	"newContactInfoClient": `newContactInfoClient_Ommdr`,
	"searchContainerIcon": `searchContainerIcon_O_n2O`,
	"inputContainerNew": `inputContainerNew_BTVd8`
};
export default ___CSS_LOADER_EXPORT___;
